import {
  gettaprequestSearchInitialFilterValues,
  gettaprequestSearchData
} from "@/services/api/tapRequest.api.js";
import locationServices from "@/services/api/location.api";
import userRoles from "@/utils/constants/userRoles";

function checkProviderRole(role) {
  const providersRoles = [
    userRoles.provider,
    userRoles.assistantprovider,
    userRoles.especialista,
    userRoles.proveedorcpa
  ];

  return providersRoles.includes(role);
}

const isAdmin = (role) => {
  const providersRoles = [
    userRoles.admin,
    userRoles.adminIl,
    userRoles.adminSaee
  ];

  return providersRoles.includes(role);
}

const getSchools = async (academicYear, center, municipality) => {
  const { data } = await locationServices.getSchools({
    academicYearId: academicYear,
    centerId: center,
    municipalityId: municipality,
  });
  
  return data;
};

export default {
  async initFilters(context) {
    context.commit("setFilterValue", { property: "academicYear", data: null });
    context.commit("resetByAcademicYear");
    context.commit("setIsAdmin", isAdmin(context.rootGetters["$_user/role"]));
    const { data } = await gettaprequestSearchInitialFilterValues();
    if (data) {
      context.commit("setFilters", data.filters);
      context.commit("setHasAccessLevel", data.hasAccessLevel);
      context.commit("setAcademicYears", data.collections.academicYears);
      context.commit("setCenters", data.collections.centers);
      if (data.collections.centers.length == 1) {
        context.dispatch("onCenterChanged");
      }
      context.commit("setMunicipalities", data.collections.municipalities);
      context.commit("setSchools", data.collections.schools);
      context.commit("setStatus", data.collections.status);
      context.commit("setAmendmentProcess", data.collections.amendmentProcess);
    }
  },
  loadResults(context, filterProperties) {
    if (!filterProperties) {
      const {
        academicYear,
        sieorRegId,
        center,
        municipality,
        school,
        status,
        requestType,
        determinationType,
        amendmentProcess
      } = context.state.filters;
      const { currentPage, pageSize } = context.state.pagination;
      filterProperties = {
        AcademicYear: academicYear?.id,
        Filter: sieorRegId,
        Amendmentprocess: amendmentProcess?.id,
        StatusId: status?.id,
        CenterId: center?.id,
        MunicipalityId: municipality?.id,
        RequestType: requestType?.id,
        DeterminationType: determinationType?.id,
        SchoolId: school?.id,
        PageIndex: currentPage,
        PageSize: pageSize
      };
    }
    filterProperties.Amendmentprocess =
      context.state.filters.amendmentProcess == null ||
      context.state.filters.amendmentProcess == undefined
        ? null
        : context.state.filters.amendmentProcess.id == 1
        ? true
        : false;
    gettaprequestSearchData(filterProperties).then(({ data }) => {
      context.commit("setResults", data.data);
      context.commit("setPagination", {
        count: data.count,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        totalPages: data.pageCount,
        totalRecords: data.totalItemCount,
        pageSize: 10
      });
    });
  },
  async onAcademicYearChanged(context) { 
    if (context.rootGetters["$_user/role"] != userRoles.provider) {
      context.commit("resetByAcademicYear");
      
      context.state.filters.center = null;
      context.state.filters.municipality = null;
      context.state.filters.status = null;
      context.state.filters.sieorRegId = null;
      context.state.filters.requestType = null;
      context.state.filters.determinationType = null;
      context.state.filters.school = null;

      const { data } = await gettaprequestSearchInitialFilterValues();
      context.commit("setCenters", data.collections.centers);
      context.commit("setMunicipalities", data.collections.municipalities);
      context.commit("setSchools", data.collections.schools);
    }
  },
  onStatusChanged(context) {
    context.state.filters.amendmentProcess = null;
  },
  loadCenters(context) {
    if (context.state.filters.academicYear != null) {
      locationServices
        .getCenters({ academicYearId: context.state.filters.academicYear.id })
        .then(({ data }) => {
          context.commit("setCenters", data);
          if (data.length == 1 && data[0].selected) {
            context.dispatch("onCenterChanged");
          }
        })
        .catch();
    }
  },
  onCenterChanged(context) {
    context.commit("resetByCenter");
    if (
      context.state.filters.academicYear != null &&
      context.state.filters.center != null
    ) {
      if (checkProviderRole(context.rootGetters["$_user/role"])) {
        locationServices
          .getProviderSchools({
            academicYearId: context.state.filters.academicYear.id,
            centerId: context.state.filters.center.id
          })
          .then(({ data }) => {
            context.commit("setSchools", data);
          })
          .catch();
      } else {
        locationServices
          .getMunicipalities({
            academicYearId: context.state.filters.academicYear.id,
            centerId: context.state.filters.center.id
          })
          .then(({ data }) => {
            context.commit("setMunicipalities", data);

            if (data.length == 1 && data[0].selected) {
              context.dispatch("onMunicipalityChanged");
            }
          })
          .catch();
      }
    } else {
      context.commit("setMunicipalities", null);
    }

    if (isAdmin(context.rootGetters["$_user/role"])) {
      getSchools(
        context.state.filters.academicYear.id,
        context.state.filters.center?.id,
        context.state.filters.municipality?.id
      ).then(schools => context.commit("setSchools", schools));
    }
  },
  onMunicipalityChanged(context) {
    context.commit("resetByMunicipality");
    if (
      context.state.filters.academicYear != null &&
      context.state.filters.center != null
    ) {
      if (checkProviderRole(context.rootGetters["$_user/role"])) {
        locationServices
          .getProviderSchools({
            academicYearId: context.state.filters.academicYear.id,
            centerId: context.state.filters.center.id
          })
          .then(({ data }) => {
            context.commit("setSchools", data);           
          })
          .catch();
      } else {
        locationServices
          .getSchools({
            academicYearId: context.state.filters.academicYear.id,
            municipalityId: context.state.filters.municipality.id
          })
          .then(({ data }) => {
            context.commit("setSchools", data);                      
          })
          .catch();
      }
    } else {
      context.commit("setMunicipalities", null);
    }

    if (isAdmin(context.rootGetters["$_user/role"])) {
      getSchools(
        context.state.filters.academicYear.id,
        context.state.filters.center?.id,
        context.state.filters.municipality?.id
      ).then(schools => context.commit("setSchools", schools));
    }
  },
  onGoToHistory(context, data) {
    context.commit("setStudentSIE", data);
  },
  resetAll({ commit }) {
    commit("resetAll");
  }
};
